import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { resetPassword } from '../../api/auth';

const notificationText =
  'A jelszó visszaállításhoz szükséges üzenetet elküldtük a postafiókodba';

export default function ResetPasswordForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const formData = useRef({ email: '' });

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { email } = formData.current;
      setLoading(true);

      const result = await resetPassword(email);
      setLoading(false);

      if (result.isOk) {
        setNotification({
          open: true,
          message: notificationText,
          severity: 'success',
        });
        navigate('/login');
      } else {
        setNotification({
          open: true,
          message: result.message,
          severity: 'error',
        });
      }
    },
    [navigate]
  );

  return (
    <Paper elevation={3} sx={{ padding: 3, maxWidth: 400, margin: '10% auto' }}>
      <form onSubmit={onSubmit}>
        <Typography variant='h5' textAlign='center' gutterBottom>
          Jelszó visszaállítása
        </Typography>
        <TextField
          fullWidth
          label='Email'
          variant='filled'
          type='email'
          required
          onChange={(e) => (formData.current.email = e.target.value)}
          sx={{ mb: 2 }}
        />
        <Box textAlign='center' mt={2}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            fullWidth
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Jelszó visszaállítása'}
          </Button>
        </Box>
        <Typography variant='body2' textAlign='center' mt={2}>
          Visszalépés a <Link to='/login'>bejelentkezéshez</Link>
        </Typography>
      </form>
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          variant='filled'
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
}
